
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/development",
      function () {
        return require("private-next-pages/development.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/development"])
      });
    }
  